
import Navigation from '../../components/feature/Navigation';
import Hero from './components/Hero';
import FeaturedPuppies from './components/FeaturedPuppies';
import Accessories from './components/Accessories';
import Boarding from './components/Boarding';
import About from './components/About';
import WhyChooseUs from './components/WhyChooseUs';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navigation />
      <Hero />
      <FeaturedPuppies />
      <Accessories />
      <Boarding />
      <About />
      <WhyChooseUs />
      <Contact />
      <Footer />
    </div>
  );
}
